import { heroData } from '@/mocks/homepage';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20inspired%20background%20with%20flowing%20ink%20waves%20in%20warm%20orange%20and%20gold%20tones%2C%20subtle%20comic%20panel%20grid%20lines%2C%20soft%20gradient%2C%20dreamy%20atmospheric%20texture%2C%20editorial%20design%20aesthetic%2C%20no%20text%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium tracking-wide mb-5 whitespace-nowrap">
              {heroData.tagline}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight mb-4">
              {heroData.title}
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 font-heading mb-6">
              {heroData.subtitle}
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20illustration%20featuring%20multiple%20anime%20characters%20in%20action%20poses%2C%20warm%20vibrant%20colors%20with%20orange%20and%20gold%20accents%2C%20comic%20style%20speed%20lines%2C%20energetic%20composition%2C%20modern%20anime%20art%2C%20clean%20background%20with%20subtle%20gradient&width=800&height=1000&seq=hero-visual-manga-01&orientation=portrait"
                alt="番茄漫画主视觉 - 热门漫画角色集结"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}